export default __webpack_public_path__ + "static/media/active.efa32809.svg";